module.exports = flarum.core.compat['common/models/LevelConf'];